import * as FormHelpers from "./external_script/forms/helpers";
import { ui } from "./multi_step_forms/ui";
import { MultiStepFormState } from "./multi_step_forms/multi_step_form_state";

const init = () => ui.forms().forEach(form => initForm(form.dataset.driftrockForm));

const initForm = (formId) => {
  const steps = readSteps(formId);
  const state = new MultiStepFormState(steps);

  setStepsVisibility(formId, state);
  setButtonVisibility(formId, state);
  setNavigationListeners(formId, state);
};

const readSteps = (formId) => ui.stepsConf(formId)?.dataset?.stepsIds?.split(",") || [];

const setButtonVisibility = (formId, state) => {
  const submitButton = ui.btnSubmit(formId);
  const previousButton = ui.btnPrev(formId);
  const nextButton = ui.btnNext(formId);
  const recaptchaContainer = ui.recaptcha(formId);

  if (state.isSingleStep()) {
    FormHelpers.showElement(submitButton);
    FormHelpers.showElement(recaptchaContainer);
    FormHelpers.hideElement(previousButton);
    FormHelpers.hideElement(nextButton);
  } else if (state.isFirstStep()) {
    FormHelpers.hideElement(submitButton);
    FormHelpers.hideElement(recaptchaContainer);
    FormHelpers.hideElement(previousButton);
    FormHelpers.showElement(nextButton);
  } else if (state.isLastStep()) {
    FormHelpers.showElement(submitButton);
    FormHelpers.showElement(recaptchaContainer);
    FormHelpers.showElement(previousButton);
    FormHelpers.hideElement(nextButton);
  } else {
    FormHelpers.hideElement(submitButton);
    FormHelpers.hideElement(recaptchaContainer);
    FormHelpers.showElement(previousButton);
    FormHelpers.showElement(nextButton);
  }
};

const setNavigationListeners = (formId, state) => {
  ui.btnPrev(formId)?.addEventListener("click", (event) => {
    event.preventDefault();
    previous(formId, state);
  });

  ui.btnNext(formId)?.addEventListener("click", (event) => {
    event.preventDefault();
    next(formId, state);
  });
}

const next = (formId, state) => {
  if (!areActiveInputsValid(formId, state)) {
    showValidationErrors(formId, state);
    return;
  }

  state.next();
  
  setStepsVisibility(formId, state);
  setButtonVisibility(formId, state);
}

const areActiveInputsValid = (formId, state) => {
  const activeInputs = ui.activeInputs(formId, state.currentStep())
  return Array.from(activeInputs).every((input) => input.checkValidity());
}
const previous = (formId, state) => {
  state.prev();

  setStepsVisibility(formId, state);
  setButtonVisibility(formId, state);
}

const setStepsVisibility = (formId, state) => {
  state
    .inactiveSteps()
    .forEach(stepId => FormHelpers.hideElement(ui.stepContainer(formId, stepId)));

  state
    .activeSteps()
    .forEach(stepId => FormHelpers.showElement(ui.stepContainer(formId, stepId)));
};

const showValidationErrors = (formId, state) => {
  ui
    .activeInputs(formId, state.currentStep())
    .forEach((input) => {
      if (input.checkValidity()) return;

      input.reportValidity();
      input.addEventListener("keydown", (_) => {
        input.setCustomValidity("");
      }, { once: true });
    });
}

const MultiStepForm = { init };

export { MultiStepForm };
